import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/medico-legal")({
  component: MedicoLegal,
  head: () => ({
    meta: [
      { title: "Medico Legal Physiotherapy Reports, Pretoria" },
      { name: "description", content: "Objective, evidence based physiotherapy reports for personal injury, RAF and loss of earnings claims. Court ready." },
      { property: "og:title", content: "Medico Legal, N S Physiotherapy" },
      { property: "og:url", content: "/medico-legal" },
    ],
    links: [{ rel: "canonical", href: "/medico-legal" }],
  }),
});

function MedicoLegal() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Professional. Reliable. Court Ready."
        title="Medico Legal Physiotherapy Reports in Pretoria"
        subtitle="Objective, evidence based physiotherapy reports for personal injury, RAF, and loss of earnings claims."
      />
      <section className="container-page py-16 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl border border-border bg-card p-6">
          <h2 className="font-display text-xl font-bold text-primary">Services offered</h2>
          <ul className="mt-4 space-y-2 text-foreground/85 list-disc pl-5">
            <li>Comprehensive Medico Legal Reports (RAF & personal injury)</li>
            <li>Functional Capacity Evaluations</li>
            <li>Impairment Assessments</li>
            <li>Return to Work Assessments</li>
            <li>Court Testimony and Expert Opinion</li>
          </ul>
        </div>
        <div className="rounded-2xl border border-border bg-card p-6">
          <h2 className="font-display text-xl font-bold text-primary">Fee structure</h2>
          <div className="mt-4 space-y-4 text-sm text-foreground/85">
            <div>
              <div className="font-semibold text-primary">Medico Legal Report</div>
              <ul className="mt-1 space-y-1 list-disc pl-5">
                <li>R700 per hour</li>
                <li>Minimum total fee: R10,000</li>
                <li>Average time: 14–16 hours</li>
                <li>A draft version can be provided for review</li>
                <li>Full report released once 60% of invoice is settled</li>
              </ul>
            </div>
            <div>
              <div className="font-semibold text-primary">Court Testimony</div>
              <ul className="mt-1 space-y-1 list-disc pl-5">
                <li>Preparation time: R700 per hour</li>
                <li>Full day appearance (08:00–17:00): R6,500</li>
                <li>Half day appearance: R3,250</li>
                <li>50% of appearance fee payable in advance to confirm booking</li>
              </ul>
            </div>
            <div>
              <div className="font-semibold text-primary">Travel</div>
              <ul className="mt-1 space-y-1 list-disc pl-5">
                <li>R300 per hour (travel time)</li>
                <li>Additional expenses: airfare, accommodation, meals (if applicable)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="container-page pb-16">
        <div className="rounded-2xl border border-border bg-secondary/60 p-6">
          <div className="font-display text-lg font-bold text-primary">Book a consultation</div>
          <p className="mt-2 text-foreground/85">For enquiries, bookings, or questions about medico legal assessments, serving all areas in Pretoria.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href={`tel:${SITE.phoneRaw}`} className="btn-hero inline-flex h-11 items-center rounded-full px-5 font-semibold">Call {SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="inline-flex h-11 items-center rounded-full border border-border bg-background px-5 font-semibold text-primary hover:bg-accent">{SITE.email}</a>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
